import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const ADMIN_TOKEN_KEY = "hpr_admin_token";
export const setAdminToken = (t) => { if (t) sessionStorage.setItem(ADMIN_TOKEN_KEY, t); else sessionStorage.removeItem(ADMIN_TOKEN_KEY); };
export const getAdminToken = () => sessionStorage.getItem(ADMIN_TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export async function submitQuoteRequest(payload) {
  const { data } = await api.post("/quote-requests", payload);
  return data;
}

export async function fetchAvailableSlots(date) {
  const { data } = await api.get("/available-slots", { params: { date } });
  return data;
}

export async function fetchReviews() {
  const { data } = await api.get("/reviews");
  return data;
}

export async function fetchGoogleReviews() {
  const { data } = await api.get("/google-reviews");
  return data;
}

export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}

export async function fetchAdminLeads() {
  const { data } = await api.post("/admin/leads", {});
  return data;
}

export async function fetchOnegoDeliveryStatus() {
  const { data } = await api.get("/admin/onengo-deliveries");
  return data;
}

export async function retryOnegoDeliveries() {
  const { data } = await api.post("/admin/onengo-deliveries/retry", {});
  return data;
}

export async function setLeadFollowupStatus(leadId, contacted) {
  const { data } = await api.post(`/admin/leads/${leadId}/followup`, { contacted });
  return data;
}

export async function createQuote(payload) {
  const { data } = await api.post("/admin/quotes", payload);
  return data;
}

export async function listQuotes() {
  const { data } = await api.post("/admin/quotes/list", {});
  return data;
}

export async function fetchQuote(publicId) {
  const { data } = await api.get(`/offert/${publicId}`);
  return data;
}

export async function acceptQuote(publicId, signedName) {
  const { data } = await api.post(`/offert/${publicId}/accept`, { signedName });
  return data;
}

export async function generateQuoteIntro(payload) {
  const { data } = await api.post("/admin/quotes/intro", payload);
  return data;
}

function blobToB64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(",", 2)[1] || "");
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

export async function uploadGreetingVideo(blob, onProgress) {
  const mime = blob.type || "video/webm";
  const { data: init } = await api.post("/admin/quotes/video/init", { mime });
  const uploadId = init.uploadId;
  const CHUNK = 512 * 1024;
  const total = Math.max(1, Math.ceil(blob.size / CHUNK));
  for (let i = 0; i < total; i++) {
    const b64 = await blobToB64(blob.slice(i * CHUNK, (i + 1) * CHUNK));
    await api.post("/admin/quotes/video/chunk", { uploadId, index: i, data: b64 });
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await api.post("/admin/quotes/video/complete", { uploadId });
  return data;
}

export async function uploadGreetingPoster(dataUrl) {
  const { data } = await api.post("/admin/quotes/poster", { data: dataUrl });
  return data;
}

export async function sendQuoteFollowups() {
  const { data } = await api.post("/admin/quotes/send-followups", {});
  return data;
}

export async function createSolarCheckout(payload) {
  const { data } = await api.post("/payments/checkout", payload);
  return data;
}

export async function fetchPaymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}

export async function checkSolarReferral(code) {
  const { data } = await api.get(`/solar-referral/${code}`);
  return data;
}

export async function fetchNeighborCredits() {
  const { data } = await api.post("/admin/neighbor-credits", {});
  return data;
}

export async function settleNeighborCredit(sessionId) {
  const { data } = await api.post("/admin/neighbor-credits/settle", { session_id: sessionId });
  return data;
}

export async function setLeadWashDate(leadId, washDate) {
  const { data } = await api.post(`/admin/leads/${leadId}/wash-date`, { washDate });
  return data;
}

export async function sendReminders(date) {
  const { data } = await api.post("/admin/send-reminders", { date: date || null });
  return data;
}

export async function sendStreetOffer(street, city) {
  const { data } = await api.post("/admin/street-offer", { street, city: city || "" });
  return data;
}

export async function downloadOwnQuotePdf(payload) {
  const res = await api.post("/admin/quote-pdf", payload, { responseType: "blob" });
  return res.data;
}

export async function visualizeHouse(payload) {
  const { data } = await api.post("/roof-visualizer", payload, { timeout: 120000 });
  return data;
}
